/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
import { VERSION } from '../../version';
import { SEMRESATTRS_TELEMETRY_SDK_NAME, SEMRESATTRS_PROCESS_RUNTIME_NAME, SEMRESATTRS_TELEMETRY_SDK_LANGUAGE, TELEMETRYSDKLANGUAGEVALUES_WEBJS, SEMRESATTRS_TELEMETRY_SDK_VERSION, } from '@opentelemetry/semantic-conventions';
/** Constants describing the SDK in use */
export var SDK_INFO = (_a = {},
    _a[SEMRESATTRS_TELEMETRY_SDK_NAME] = 'opentelemetry',
    _a[SEMRESATTRS_PROCESS_RUNTIME_NAME] = 'browser',
    _a[SEMRESATTRS_TELEMETRY_SDK_LANGUAGE] = TELEMETRYSDKLANGUAGEVALUES_WEBJS,
    _a[SEMRESATTRS_TELEMETRY_SDK_VERSION] = VERSION,
    _a);
//# sourceMappingURL=sdk-info.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@opentelemetry/core/build/esm/platform/browser/sdk-info.js
// module id = 1929
// module chunks = 0